import React, { useState } from 'react';
import './ShareModal.css';

const ShareModal = ({ onClose, onShare }) => {
  const [copyStatus, setCopyStatus] = useState('Copy Link');

  const shareOptions = [
    { id: 'messages', name: 'Messages', icon: '💬', color: '#34C759' },
    { id: 'whatsapp', name: 'WhatsApp', icon: '📱', color: '#25D366' },
    { id: 'instagram', name: 'Instagram', icon: '📸', color: '#E1306C' },
    { id: 'telegram', name: 'Telegram', icon: '✈️', color: '#0088CC' },
    { id: 'x', name: 'X / Twitter', icon: '🐦', color: '#000000' },
    { id: 'facebook', name: 'Facebook', icon: '👥', color: '#1877F2' },
    { id: 'slack', name: 'Slack', icon: '🚀', color: '#4A154B' },
    { id: 'pinterest', name: 'Pinterest', icon: '📌', color: '#BD081C' },
    { id: 'email', name: 'Email', icon: '✉️', color: '#888888' },
  ];

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopyStatus('Copied!');
    setTimeout(() => setCopyStatus('Copy Link'), 2000);
  };

  return (
    <div className="share-sheet-overlay" onClick={onClose}>
      <div className="share-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="share-handle"></div>
        <div className="share-header">
          <h3>Share Your Build</h3>
          <p>Show off your custom rig to the world.</p>
        </div>

        <div className="share-options-scroll">
          {shareOptions.map((option) => (
            <button 
              key={option.id} 
              className="share-option-btn"
              onClick={() => onShare(option.id)}
            >
              <div className="share-icon-wrapper" style={{ backgroundColor: option.color }}>
                <span className="share-icon">{option.icon}</span>
              </div>
              <span className="share-name">{option.name}</span>
            </button>
          ))}
        </div>

        <div className="share-actions-footer">
          <button className="copy-link-btn" onClick={handleCopyLink}>
            <span className="link-icon">🔗</span>
            {copyStatus}
          </button>
          <button className="close-share-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
